import { Http } from "../Http";
import { AxiosPromise } from "axios";
import apiCall from "./apiCall.js";
import apiConfig from "../../config/apiConfig";

const samplePlanApi = {
	getSamplePlans: async (input) => {
		const id = input.userId ?? input.id;
		const siteId = input.siteId ? input.siteId : 0;
		const url =
			"SamplePlan/GetAll?userId=" + id + "&userToken=" + input.userToken + "&sortField=" +
			input.sortField + "&sortDirection=" + input.sortDirection + "&siteId=" + siteId;
		const response = await apiCall(url, "get");
		return response;
	},

	getTestPoints: async (input) => {
		const url =
			"TestPoint/GetAllTestPoint?userId=" +
			input.userId +
			"&userToken=" +
			input.userToken;
		const response = await apiCall(url, "get");
		return response;
	},

	saveSamplePlan: async (input) => {
		let isLive = input.isLive;
		if (!isLive) {
			isLive = false;
		}

		if (!input.id) {
			input.id = 0;
		}

		const data = {
			...input,
			id: 0,
			isLive: isLive,
		};
		const obj = JSON.stringify(data);
		const url =
			"SamplePlan/Add" +
			"?userId=" +
			input.userId +
			"&userToken=" +
			input.userToken;
		const response = await apiCall(url, "post", obj);
		return response;
	},

	addFromTemplate: async (input) => {
		const obj = JSON.stringify(input);
		const url =
			"SamplePlan/AddFromTemplate" +
			"?userId=" +
			input.userId +
			"&userToken=" +
			input.userToken;
		const response = await apiCall(url, "post", obj);
		return response;
	},

	updateSamplePlan: async (input) => {
		const obj = JSON.stringify(input);
		const url =
			"SamplePlan/Update" +
			"?userId=" +
			input.userId +
			"&userToken=" +
			input.userToken +
			"&id=" +
			input.id;
		const response = await apiCall(url, "put", obj);
		return response;
	},

	deleteSamplePlan: async (input) => {
		const obj = JSON.stringify(input);
		const url =
			"SamplePlan/Delete" +
			"?userId=" +
			input.userId +
			"&userToken=" +
			input.userToken +
			"&id=" +
			input.id;
		const response = await apiCall(url, "delete");
		return response;
	},

	importSamplePlan: async (input) => {
		// Transform mappings array to Mapping object
		const mapping = {};
		if (input.mappings && Array.isArray(input.mappings)) {
			input.mappings.forEach(item => {
				mapping[item.name] = item.value;
			});
		}

		// Strip any data URL prefix from the file (e.g., "data:text/csv;base64," or "data:application/vnd.ms-excel;base64,")
		let fileContent = input.file;
		if (fileContent && fileContent.includes(',')) {
			const commaIndex = fileContent.indexOf(',');
			if (fileContent.substring(0, commaIndex).includes('base64')) {
				fileContent = fileContent.substring(commaIndex + 1);
			}
		}

		// Create the payload with correct structure (excluding userId and userToken from body)
		const payload = {
			Frequency: input.frequency,
			DayOfWeek: input.dayOfWeek,
			DayOfMonth: input.dayOfMonth,
			IsOccurrence: input.isOccurrence || false,
			WeekOfMonth: input.weekOfMonth || null,
			DayOfWeekOccurrence: input.dayOfWeekOccurrence || null,
			StartDate: input.startDate || null,
			SiteIds: input.siteIds,
			Mapping: mapping,
			File: fileContent
		};

		const obj = JSON.stringify(payload);
		// userId and userToken must be in query parameters, not in the body
		const url =
			"SamplePlan/Import" +
			"?userId=" +
			input.userId +
			"&userToken=" +
			input.userToken;
		const response = await apiCall(url, "post", obj);
		return response;
	},
};

export default samplePlanApi;

// export class SampleplanApi {
// 	public static getSamplePlans(input: any) {
// 		return Http.axios().get('/SamplePlan/GetAll?userId=' + input.userId
// 			+ "&userToken=" + input.userToken)
// 			.catch((e) => {
// 				return e.response;
// 			}) as AxiosPromise<any>;
// 	}

// 	public static getTestPoints(input: any) {
// 		return Http.axios().get('/TestPoint/GetAllTestPoint?userId=' + input.userId
// 			+ "&userToken=" + input.userToken)
// 			.catch((e) => {
// 				return e.response;
// 			}) as AxiosPromise<any>;
// 	}

// 	public static saveSamplePlan(input: any) {
// 		var obj = JSON.stringify(input);
// 		return Http.axios().post('/SamplePlan/SaveSamplePlan', obj, { headers: { 'Content-Type': 'application/json' } })
// 			.then(response => {
// 				return response;
// 			}).catch((e) => {
// 				return e.response;
// 			}) as AxiosPromise<any>;
// 	}

// 	public static deleteSamplePlan(input: any) {
// 		var obj = JSON.stringify(input);
// 		return Http.axios().post('/SamplePlan/DeleteSamplePlan', obj, { headers: { 'Content-Type': 'application/json' } })
// 			.then(response => {
// 				return response;
// 			}).catch((e) => {
// 				return e.response;
// 			}) as AxiosPromise<any>;
// 	}

// 	public static importSamplePlan(input: any) {
// 		var obj = JSON.stringify(input);
// 		return Http.axios().post('/SamplePlan/ImportPlan', obj, { headers: { 'Content-Type': 'application/json' } })
// 			.then(response => {
// 				return response;
// 			}).catch((e) => {
// 				return e.response;
// 			}) as AxiosPromise<any>;
// 	}
// }
